namespace com.enirva.event
{
	/*
	 * Eventクラス
	 */
	export class Event
	{
		public static COMPLETE:string = "complete";
		
		public static CHANGE:string = "change";
		
		public target:any;
		
		public type:string;
		
		constructor(type:string)
		{
			this.type = type;
		}
	}
}

